export const initialStatePlanning = {
  loading: true,
  data: null,
};

export const initialStateActionForCreateOrEditModal = {
  type: "create",
  data: null,
};

export const initialStateEditFile = {
  isOpen: false,
  current: null,
};

export const initialStateDeleteFile = {
  isOpen: false,
  currentFile: null,
};

export const initialStateToForm = (data = {}) => ({
  editType: data.editType ?? "create",
  id: data.id ?? null,
  typeId: data.typeId,
  contentId: data.contentId ?? null,
  episodeNumber: data.episodeNumber ?? null,
  version: data.version ?? 1,
  numberChaptersBlock: data.numberChaptersBlock ?? null,
  planning: {
    delivery: data.planning?.delivery ?? null,
    release: data.planning?.release ?? null,
    channelNotes: data.planning?.channelNotes ?? null,
    productionAssessment: data.planning?.productionAssessment ?? null,
    contentAssessment: data.planning?.contentAssessment ?? null,
    diversityAssessment: data.planning?.diversityAssessment ?? null,
  },
});
